import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of standing-order protocols that are overdue or due within 30
 *  days, for review-due nav/button tickers. `path` differs per portal. */
export function useStandingOrdersReview(path, enabled = true, intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!enabled || !path) { setCount(0); return; }
        let active = true;
        const fetchCount = () => api.get(path)
            .then((r) => { if (active) setCount(r.data.count || 0); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        return () => { active = false; clearInterval(id); };
    }, [path, enabled, intervalMs]);
    return count;
}
